import * as i0 from '@angular/core';
import { Directive, inject, DestroyRef, EventEmitter, ContentChild, Output, Input, ViewEncapsulation, ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { __esDecorate, __runInitializers } from 'tslib';
import { Location } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import * as i1 from 'ng-zorro-antd/core/config';
import { WithConfig } from 'ng-zorro-antd/core/config';
import * as i4 from 'ng-zorro-antd/core/outlet';
import { NzOutletModule } from 'ng-zorro-antd/core/outlet';
import * as i5 from 'ng-zorro-antd/icon';
import { NzIconModule } from 'ng-zorro-antd/icon';
import * as i2 from 'ng-zorro-antd/cdk/resize-observer';
import * as i3 from '@angular/cdk/bidi';

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
const _c0 = [[["nz-breadcrumb", "nz-page-header-breadcrumb", ""]], [["nz-avatar", "nz-page-header-avatar", ""]], [["nz-page-header-tags"], ["", "nz-page-header-tags", ""]], [["nz-page-header-extra"], ["", "nz-page-header-extra", ""]], [["nz-page-header-content"], ["", "nz-page-header-content", ""]], [["nz-page-header-footer"], ["", "nz-page-header-footer", ""]], [["nz-page-header-title"], ["", "nz-page-header-title", ""]], [["nz-page-header-subtitle"], ["", "nz-page-header-subtitle", ""]]];
const _c1 = ["nz-breadcrumb[nz-page-header-breadcrumb]", "nz-avatar[nz-page-header-avatar]", "nz-page-header-tags, [nz-page-header-tags]", "nz-page-header-extra, [nz-page-header-extra]", "nz-page-header-content, [nz-page-header-content]", "nz-page-header-footer, [nz-page-header-footer]", "nz-page-header-title, [nz-page-header-title]", "nz-page-header-subtitle, [nz-page-header-subtitle]"];
function NzPageHeaderComponent_Conditional_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "nz-icon", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const backIcon_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzType", backIcon_r3 || ctx_r1.getBackIcon());
  }
}
function NzPageHeaderComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function NzPageHeaderComponent_Conditional_3_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBack());
    });
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵtemplate(2, NzPageHeaderComponent_Conditional_3_ng_container_2_Template, 2, 1, "ng-container", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r1.nzBackIcon);
  }
}
function NzPageHeaderComponent_Conditional_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.nzTitle);
  }
}
function NzPageHeaderComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵtemplate(1, NzPageHeaderComponent_Conditional_5_ng_container_1_Template, 2, 1, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r1.nzTitle);
  }
}
function NzPageHeaderComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 6);
  }
}
function NzPageHeaderComponent_Conditional_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.nzSubtitle);
  }
}
function NzPageHeaderComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtemplate(1, NzPageHeaderComponent_Conditional_7_ng_container_1_Template, 2, 1, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("nzStringTemplateOutlet", ctx_r1.nzSubtitle);
  }
}
function NzPageHeaderComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 7);
  }
}
let NzPageHeaderTitleDirective = /*#__PURE__*/(() => {
  class NzPageHeaderTitleDirective {
    static ɵfac = function NzPageHeaderTitleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzPageHeaderTitleDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzPageHeaderTitleDirective,
      selectors: [["nz-page-header-title"], ["", "nz-page-header-title", ""]],
      hostAttrs: [1, "ant-page-header-heading-title"],
      exportAs: ["nzPageHeaderTitle"]
    });
  }
  return NzPageHeaderTitleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NzPageHeaderSubtitleDirective = /*#__PURE__*/(() => {
  class NzPageHeaderSubtitleDirective {
    static ɵfac = function NzPageHeaderSubtitleDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzPageHeaderSubtitleDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzPageHeaderSubtitleDirective,
      selectors: [["nz-page-header-subtitle"], ["", "nz-page-header-subtitle", ""]],
      hostAttrs: [1, "ant-page-header-heading-sub-title"],
      exportAs: ["nzPageHeaderSubtitle"]
    });
  }
  return NzPageHeaderSubtitleDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NzPageHeaderContentDirective = /*#__PURE__*/(() => {
  class NzPageHeaderContentDirective {
    static ɵfac = function NzPageHeaderContentDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzPageHeaderContentDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzPageHeaderContentDirective,
      selectors: [["nz-page-header-content"], ["", "nz-page-header-content", ""]],
      hostAttrs: [1, "ant-page-header-content"],
      exportAs: ["nzPageHeaderContent"]
    });
  }
  return NzPageHeaderContentDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NzPageHeaderTagDirective = /*#__PURE__*/(() => {
  class NzPageHeaderTagDirective {
    static ɵfac = function NzPageHeaderTagDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzPageHeaderTagDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzPageHeaderTagDirective,
      selectors: [["nz-page-header-tags"], ["", "nz-page-header-tags", ""]],
      hostAttrs: [1, "ant-page-header-heading-tags"],
      exportAs: ["nzPageHeaderTags"]
    });
  }
  return NzPageHeaderTagDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NzPageHeaderExtraDirective = /*#__PURE__*/(() => {
  class NzPageHeaderExtraDirective {
    static ɵfac = function NzPageHeaderExtraDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzPageHeaderExtraDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzPageHeaderExtraDirective,
      selectors: [["nz-page-header-extra"], ["", "nz-page-header-extra", ""]],
      hostAttrs: [1, "ant-page-header-heading-extra"],
      exportAs: ["nzPageHeaderExtra"]
    });
  }
  return NzPageHeaderExtraDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NzPageHeaderFooterDirective = /*#__PURE__*/(() => {
  class NzPageHeaderFooterDirective {
    static ɵfac = function NzPageHeaderFooterDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzPageHeaderFooterDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzPageHeaderFooterDirective,
      selectors: [["nz-page-header-footer"], ["", "nz-page-header-footer", ""]],
      hostAttrs: [1, "ant-page-header-footer"],
      exportAs: ["nzPageHeaderFooter"]
    });
  }
  return NzPageHeaderFooterDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NzPageHeaderBreadcrumbDirective = /*#__PURE__*/(() => {
  class NzPageHeaderBreadcrumbDirective {
    static ɵfac = function NzPageHeaderBreadcrumbDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzPageHeaderBreadcrumbDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzPageHeaderBreadcrumbDirective,
      selectors: [["nz-breadcrumb", "nz-page-header-breadcrumb", ""]],
      exportAs: ["nzPageHeaderBreadcrumb"]
    });
  }
  return NzPageHeaderBreadcrumbDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NzPageHeaderAvatarDirective = /*#__PURE__*/(() => {
  class NzPageHeaderAvatarDirective {
    static ɵfac = function NzPageHeaderAvatarDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzPageHeaderAvatarDirective)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: NzPageHeaderAvatarDirective,
      selectors: [["nz-avatar", "nz-page-header-avatar", ""]],
      exportAs: ["nzPageHeaderAvatar"]
    });
  }
  return NzPageHeaderAvatarDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const NZ_CONFIG_MODULE_NAME = 'pageHeader';
let NzPageHeaderComponent = (() => {
  let _nzGhost_decorators;
  let _nzGhost_initializers = [];
  let _nzGhost_extraInitializers = [];
  return class NzPageHeaderComponent {
    static {
      const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
      _nzGhost_decorators = [WithConfig()];
      __esDecorate(null, null, _nzGhost_decorators, {
        kind: "field",
        name: "nzGhost",
        static: false,
        private: false,
        access: {
          has: obj => "nzGhost" in obj,
          get: obj => obj.nzGhost,
          set: (obj, value) => {
            obj.nzGhost = value;
          }
        },
        metadata: _metadata
      }, _nzGhost_initializers, _nzGhost_extraInitializers);
      if (_metadata) Object.defineProperty(this, Symbol.metadata, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: _metadata
      });
    }
    nzConfigService;
    elementRef;
    nzResizeObserver;
    cdr;
    directionality;
    location = inject(Location);
    destroyRef = inject(DestroyRef);
    _nzModuleName = NZ_CONFIG_MODULE_NAME;
    nzBackIcon = null;
    nzTitle;
    nzSubtitle;
    nzGhost = __runInitializers(this, _nzGhost_initializers, true);
    nzBack = (__runInitializers(this, _nzGhost_extraInitializers), new EventEmitter());
    nzPageHeaderFooter;
    nzPageHeaderBreadcrumb;
    compact = false;
    dir = 'ltr';
    enableBackButton = true;
    constructor(nzConfigService, elementRef, nzResizeObserver, cdr, directionality) {
      this.nzConfigService = nzConfigService;
      this.elementRef = elementRef;
      this.nzResizeObserver = nzResizeObserver;
      this.cdr = cdr;
      this.directionality = directionality;
    }
    ngOnInit() {
      this.directionality.change?.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(direction => {
        this.dir = direction;
        this.cdr.detectChanges();
      });
      this.dir = this.directionality.value;
    }
    ngAfterViewInit() {
      if (!this.nzBack.observers.length) {
        this.enableBackButton = this.location.getState()?.navigationId > 1;
        // Location is not an RxJS construct, as a result, we can't pipe it.
        const subscription = this.location.subscribe(() => {
          this.enableBackButton = true;
          this.cdr.detectChanges();
        });
        this.destroyRef.onDestroy(() => subscription.unsubscribe());
      }
      this.nzResizeObserver.observe(this.elementRef).pipe(map(([entry]) => entry.contentRect.width), takeUntilDestroyed(this.destroyRef)).subscribe(width => {
        this.compact = width < 768;
        this.cdr.markForCheck();
      });
    }
    onBack() {
      if (this.nzBack.observers.length) {
        this.nzBack.emit();
      } else {
        this.location.back();
      }
    }
    getBackIcon() {
      if (this.dir === 'rtl') {
        return 'arrow-right';
      }
      return 'arrow-left';
    }
    static ɵfac = function NzPageHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzPageHeaderComponent)(i0.ɵɵdirectiveInject(i1.NzConfigService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.NzResizeObserver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3.Directionality));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NzPageHeaderComponent,
      selectors: [["nz-page-header"]],
      contentQueries: function NzPageHeaderComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, NzPageHeaderFooterDirective, 5);
          i0.ɵɵcontentQuery(dirIndex, NzPageHeaderBreadcrumbDirective, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nzPageHeaderFooter = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nzPageHeaderBreadcrumb = _t.first);
        }
      },
      hostAttrs: [1, "ant-page-header"],
      hostVars: 10,
      hostBindings: function NzPageHeaderComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("has-footer", ctx.nzPageHeaderFooter)("ant-page-header-ghost", ctx.nzGhost)("has-breadcrumb", ctx.nzPageHeaderBreadcrumb)("ant-page-header-compact", ctx.compact)("ant-page-header-rtl", ctx.dir === "rtl");
        }
      },
      inputs: {
        nzBackIcon: "nzBackIcon",
        nzTitle: "nzTitle",
        nzSubtitle: "nzSubtitle",
        nzGhost: "nzGhost"
      },
      outputs: {
        nzBack: "nzBack"
      },
      exportAs: ["nzPageHeader"],
      ngContentSelectors: _c1,
      decls: 13,
      vars: 3,
      consts: [[1, "ant-page-header-heading"], [1, "ant-page-header-heading-left"], [1, "ant-page-header-back"], [1, "ant-page-header-heading-title"], [1, "ant-page-header-heading-sub-title"], [1, "ant-page-header-back", 3, "click"], ["role", "button", "tabindex", "0", 1, "ant-page-header-back-button"], [4, "nzStringTemplateOutlet"], ["nzTheme", "outline", 3, "nzType"]],
      template: function NzPageHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c0);
          i0.ɵɵprojection(0);
          i0.ɵɵelementStart(1, "div", 0)(2, "div", 1);
          i0.ɵɵconditionalCreate(3, NzPageHeaderComponent_Conditional_3_Template, 3, 1, "div", 2);
          i0.ɵɵprojection(4, 1);
          i0.ɵɵconditionalCreate(5, NzPageHeaderComponent_Conditional_5_Template, 2, 1, "span", 3)(6, NzPageHeaderComponent_Conditional_6_Template, 1, 0);
          i0.ɵɵconditionalCreate(7, NzPageHeaderComponent_Conditional_7_Template, 2, 1, "span", 4)(8, NzPageHeaderComponent_Conditional_8_Template, 1, 0);
          i0.ɵɵprojection(9, 2);
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(10, 3);
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(11, 4);
          i0.ɵɵprojection(12, 5);
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx.nzBackIcon !== null && ctx.enableBackButton ? 3 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.nzTitle ? 5 : 6);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(ctx.nzSubtitle ? 7 : 8);
        }
      },
      dependencies: [NzOutletModule, i4.NzStringTemplateOutletDirective, NzIconModule, i5.NzIconDirective],
      encapsulation: 2,
      changeDetection: 0
    });
  };
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
const NzPageHeaderCells = [NzPageHeaderTitleDirective, NzPageHeaderSubtitleDirective, NzPageHeaderContentDirective, NzPageHeaderTagDirective, NzPageHeaderExtraDirective, NzPageHeaderFooterDirective, NzPageHeaderBreadcrumbDirective, NzPageHeaderAvatarDirective];
let NzPageHeaderModule = /*#__PURE__*/(() => {
  class NzPageHeaderModule {
    static ɵfac = function NzPageHeaderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NzPageHeaderModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NzPageHeaderModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [NzPageHeaderComponent]
    });
  }
  return NzPageHeaderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzPageHeaderAvatarDirective, NzPageHeaderBreadcrumbDirective, NzPageHeaderComponent, NzPageHeaderContentDirective, NzPageHeaderExtraDirective, NzPageHeaderFooterDirective, NzPageHeaderModule, NzPageHeaderSubtitleDirective, NzPageHeaderTagDirective, NzPageHeaderTitleDirective };
